import Section_1 from "../../Components/Register/Section-1";

export default function Register() {
    return <>
        <Section_1 />
    </>
}